import {
  CmpSelectBox,
  CmpButton,
  CmpDatePicker,
} from "../../Component/Common/ToolBox/ToolBox";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useSelector } from "react-redux";
//   import { PickingHead_Set } from "./SlicePickingHead";
import moment from "moment";
import {
  fAlertToast,
  GetGitterColumns,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";
import Breadcrumbs from "./component/BreadCrumbs";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  WHPicking_Attributes_GETROW,
  WHPicking_Summary_GETROW,
} from "./../../Server/ApiV2";
import GCSummaryModal from "../../Component/Common/ReuseableComponent/GCSummaryModal";
import {
  Detail_Set,
  Head_Set,
  Set_WHPicking_SummaryObj,
} from "./SliceWHPicking";
import { SummaryTblCard } from "./component/SummaryTblCard";
import { vRdxUserInfo } from "../../Redux/roStore";
import { SummaryTblCardv1 } from "./component/SummaryTblCardv1";

const columns = [
  {
    field: "A_VocTyp",
    headerName: "VocTyp",
    width: 150,
  },
  {
    field: "A_VocNo",
    headerName: "VocNo",
    width: 150,
  },
  {
    field: "A_VocDt",
    headerName: "Date",
    width: 200,
    valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
  },
  {
    field: "A_FromDt",
    headerName: "From Date",
    width: 200,
    valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
  },
  {
    field: "A_ToDate",
    headerName: "To Date",
    width: 200,
    valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
  },
  {
    field: "A_Loc",
    headerName: "A_Loc",
    width: 100,
  },
  {
    field: "A_TransTyp",
    headerName: "TransTyp",
    width: 300,
  },
  {
    field: "A_Cluster",
    headerName: "Cluster",
    width: 300,
  },
  {
    field: "A_LDBAY",
    headerName: "LDBAY",
    width: 300,
  },
  {
    field: "A_Typ",
    headerName: "Typ",
    width: 300,
  },
  {
    field: "A_DocStat",
    headerName: "DocStat",
    width: 300,
  },
  {
    field: "A_PKL_DocStatus",
    headerName: "Status",
    width: 200,
  },
];
export default function WHPickingSummary() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const LocWithoutRights = useSelector(
    (state) => state.SliceDB.value.Location.LocWithoutRights
  );

  const sData = useSelector(
    (state) => state.SliceWHPicking.value.SummaryObj
  );
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const LocationFocusOnLoad = useRef(null);
  const [sLocation, setLoc] = useState([]);
  const [sLocationsWithAll, setocationsWithAll] = useState([]);
  const statusData = [
    {
      id: "0",
      statusName: "Pending",
    },
    {
      id: "1",
      statusName: "Posted",
    },
  ];
  const [sGridRow, setGridRow] = useState([]);
  // modal start

  const [showModal, setShowModal] = useState(false);

  // modal end

  const fLoad = (e) => {
    dispatch(
      Set_WHPicking_SummaryObj({
        ...sData,
      })
    );
    GetData(
      sData.loc,
      sData.dateFrom,
      sData.dateTo,
      sData.statusVal,
      "" //empty means
      // sData.DocNo
    );
  };

  const GetData = async (xLoc, xFromDate, xToDate, xStatus, ReqLoc = "All") => {
    var vPickingData = {
      Loc: xLoc,
      StartDate: moment(xFromDate).format("MM/DD/YYYY"),
      EndDate: moment(xToDate).format("MM/DD/YYYY"),
      PickStatus: xStatus,
      ReqLoc: ReqLoc == "All" ? "" : ReqLoc,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(vPickingData);
    const vSearch = await WHPicking_Summary_GETROW(FinalObj);
    if (vSearch.status === 200) {
      if (vSearch?.data?.ResultSet.length > 0) {
        let iResp = vSearch?.data?.ResultSet?.map((obj, i) => ({
          ...obj,
          id: i + 1,
        }));
        setGridRow(iResp);
        setShowModal(false);
      } else {
        setGridRow([]);
        setShowModal(false);
      }
    }
  };

  const [sSummaryGridColumn2, setSummaryGridColumn2] = useState(columns);

  // useEffect(() => {
  //   GetGitterColumns(setSummaryGridColumn2, "WMPKLSTGSUMWB", columns);
  // }, []);
  const GetAttributes = async (setLoc) => {
    const vRdxUserInfoObj = vRdxUserInfo();
    var vObj = {
      userCode: vRdxUserInfoObj.UserID,
    };
    const iAttributes = await WHPicking_Attributes_GETROW(vObj);

    console.log(iAttributes);

    if (iAttributes?.status === 200) {
      setLoc(iAttributes?.data?.ResultSet?.Loc);
      return iAttributes?.data?.ResultSet;
    } else {
      return [];
    }
  };
  const onload = async () => {
    dispatch(Detail_Set(""));
    let iAttributeResp = await GetAttributes(setLoc);
    setocationsWithAll([...LocWithoutRights, { Uid: "All", Name1: "All" }]);
    if (iAttributeResp?.Loc.length > 0) {
      // vLoc = iAttributeResp?.Loc[0];

      dispatch(
        Set_WHPicking_SummaryObj({
          ...sData,
          loc: iAttributeResp?.Loc[0].UID,
        })
      );
      GetData( sData.loc,sData.dateFrom, sData.dateTo, sData.statusVal,sData.location);
    }
  };
  useEffect(() => {
    onload();
  }, []);

  useEffect(() => {
    LocationFocusOnLoad.current?.focus();
  }, []);
  return (
    <div className="container-fluid my-3">
      <div className="Breadcrumbs d-flex justify-content-between align-items-center">
        {/* eslint-disable-next-line react/jsx-pascal-case */}
        <Breadcrumbs />{" "}
        <CmpButton
          xbtnName="Filter"
          xOnClick={() => {
            setShowModal(true);
          }}
          xVariant="contained"
          xSize="small"
        />
      </div>
      <div className="container-head">
        <SummaryTblCardv1
          onClick={(item) => {
            console.log(item);
            dispatch(
              Head_Set({
                VocType: item.row.VocType,
                VocNo: item.row.VocNo,
                VocName: item.row.VocName,
                A_VocDt: item.row.A_VocDt,
                A_Loc: item.row.A_Loc,
                LocName: item.row.LocName,
                Picker: item.row.Picker || "",
                PickerName: item.row.PickerName || "",
                PickedDate: item.row.PickedDate || "",
                Status: item.row.Status,
                A_PickStartTime: item.row.A_PickStartTime || "",
                A_PickEndTime: item.row.A_PickEndTime || "",
                RequestLocName: item.row.RequestLocName || "",
              })
            );
            dispatch(Detail_Set(item.row.A_DropId || ""));
            navigate("/WHPickingDetail");
          }}
          data={sGridRow}
        />
      </div>
      <GCSummaryModal
        xOpen={showModal}
        fCloseModal={() => {
          setShowModal(false);
        }}
        xTitle="Filter"
        component={
          <>
            <Grid container spacing={2} className="align-items-center">
              <Grid
                item
                // lg={2} md={4}
                xs={6}
              >
                <CmpSelectBox
                  xref={LocationFocusOnLoad}
                  xLabelText="Warehouse"
                  xValue={sData.loc}
                  xOnChange={(e) => {
                    dispatch(
                      Set_WHPicking_SummaryObj({
                        ...sData,
                        loc: e.target.value,
                      })
                    )
                  }}
                  xName={"loc"}
                  xData={sLocation}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={false}
                  xErrorMessage={false}
                  xDisable={false}
                />
              </Grid>
              <Grid
                item
                // lg={2} md={4}
                xs={6}
              >
                <CmpSelectBox
                  xref={LocationFocusOnLoad}
                  xLabelText="Location"
                  xValue={sData.location}
                  xOnChange={(e) => {
                    dispatch(
                      Set_WHPicking_SummaryObj({
                        ...sData,
                        location: e.target.value,
                      })
                    );
                  }}
                  xName={"loc"}
                  xData={sLocationsWithAll}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={false}
                  xErrorMessage={false}
                  xDisable={false}
                />
              </Grid>
              <Grid
                item
                // lg={2} md={4}
                xs={6}
                className="bintransfer-data-date"
              >
                <CmpDatePicker
                  xLabelText={"From"}
                  xValue={sData.dateFrom}
                  xOnChange={(newValue) => {
                    dispatch(
                      Set_WHPicking_SummaryObj({
                        ...sData,
                        dateFrom: newValue.$d,
                      })
                    );
                  }}
                  xName={"dateFrom"}
                  xError={false}
                  xErrorMessage={false}
                />
              </Grid>
              <Grid
                item
                // lg={2} md={4}
                xs={6}
                className="bintransfer-data-date"
              >
                <CmpDatePicker
                  xLabelText={"To"}
                  xValue={sData.dateTo}
                  xOnChange={(newValue) => {
                    dispatch(
                      Set_WHPicking_SummaryObj({
                        ...sData,
                        dateTo: newValue.$d,
                      })
                    );
                  }}
                  xName={"dateTo"}
                  xError={false}
                  xErrorMessage={false}
                />
              </Grid>
              <Grid
                item
                // lg={2} md={4}
                xs={6}
              >
                <CmpSelectBox
                  xLabelText="Status"
                  xValue={
                    sData.statusVal == "" ? statusData[0].id : sData.statusVal
                  }
                  xOnChange={(e) => {
                    dispatch(
                      Set_WHPicking_SummaryObj({
                        ...sData,
                        statusVal: e.target.value,
                      })
                    );
                  }}
                  xName={"statusVal"}
                  xData={statusData}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={false}
                  xErrorMessage={false}
                  xDisable={false}
                />
              </Grid>

              <Grid
                item
                // lg={2}
                // md={4}
                xs={12}
                className="bintransfet-data-load-btn text-center"
              >
                <CmpButton
                  xbtnName="Load"
                  xOnClick={fLoad}
                  xVariant="contained"
                  xSize="small"
                />
              </Grid>
            </Grid>
          </>
        }
      />
    </div>
  );
}
